<template>
    <div class="cc-payment" v-if="shouldPaymentBeShown" @click="setPayment(payment.uniqueName)">
        <div class="cc-payment__selector">
            <div class="cc-selector cc-selector--radio cc-selector--big" v-bind:class="{'cc-active': isPaymentSelectedPayment}"></div>
        </div>
        <div class="cc-payment__image" v-if="thumbnail">
            <img :src="thumbnail" :alt="payment.title" class="cc-payment__image__thumbnail">
        </div>
        <div class="cc-payment__description">
            <div class="cc-payment__title">{{ payment.title }}</div>
        </div>
        <div class="cc-payment__prices">
            <div class="cc-payment__price">{{ displayPaymentPrice }}</div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                selectedPayment: state => state.selectedPayment,
                thumbnails: state => state.paymentMethodThumbnails,
            }),
            shouldPaymentBeShown: function () {
                if (this.selectedPayment && this.selectedPayment === this.payment.uniqueName) {
                    return true;
                }

                if (this.selectedPayment === null && this.payment.active === true) {
                    return true;
                }

                return false;
            },
            isPaymentSelectedPayment: function () {
                return this.payment.uniqueName === this.selectedPayment;
            },
            displayPaymentPrice: function () {
                return this.payment.free ? this.translations['Free'] : this.payment.formattedPrices.price;
            },
            thumbnail: function () {
              if (this.payment.name === 'pms_gopay_extra') {
                let typeName = this.payment.linkElement.classList.toString().trim();
                if (typeName) {
                  let computedStyle = getComputedStyle(document.querySelector('a.'+typeName));
                  let propertyValue = computedStyle.getPropertyValue('background-image');
                  let url = propertyValue.slice(4, -1).replace(/"/g, "");
                  return url;
                }
              }
              if (this.payment.name in this.thumbnails) {
                return this.thumbnails[this.payment.name];
              }

              return this.payment.img;
            }
        },
        methods: {
            setPayment: function (uniqueName) {
                this.$store.dispatch('SELECT_PAYMENT', uniqueName);
            },
        },
        name: 'Payments',
        props: [
            'payment',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-payment {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            border-width: 1px;
            border-style: solid;
            border-color: $border-color;

            & + .cc-payment {
                margin-top: 1.5rem;
            }

            &.cc-invalid {
                outline: none;
                box-shadow: $invalid-input-shadow;
            }
        }

        .cc-payment__selector {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            width: 10%;
            padding: 1.5rem;
        }

        @include mobile {
            .cc-payment__selector {
                align-items: flex-start;
                justify-content: flex-start;
                width: 20%;
            }
        }

        .cc-payment__image {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            width: 10%;
            padding: 1.5rem;
        }

        @include mobile {
            .cc-payment__image {
                align-items: flex-start;
                width: 20%;
                padding-right: 0;
                padding-left: 0;
            }
        }

        .cc-payment__image__thumbnail {
            display: inline-block;
            max-width: 100%;
        }

        .cc-payment__description {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            flex-wrap: wrap;
            justify-content: center;
            width: 60%;
            padding: 1.5rem;
        }

        .cc-payment__title {
            font-size: 16px;
        }

        .cc-payment__prices {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            width: 20%;
            padding: 1.5rem;
        }

        @include mobile {
            .cc-payment__prices {
                justify-content: flex-start;
                width: 60%;
                margin-left: 40%;
                padding-top: 0;
            }
        }

        .cc-payment__price {
            font-size: 18px;
            font-weight: bold;
        }
    }
</style>
